// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
const React = require('react')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
const { ago } = require('shared/date')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const LazyImage = require('client-v2/common/components/lazy-image')
const { VISIBILITY_PRIVATE } = require('client-v2/common/models/collection/record')
// Sibling imports
const { COLLECTION_UPDATE_PENDING } = require('../actions')
const CollectionListItemRecord = require('../records/collection-list-item')

const bem = BemEntity('CollectionSelectModalCollectionListItem')

class CollectionSelectModalCollectionListItem extends React.Component {
  constructor(props) {
    super(props)

    // Selectors

    this.modifiedAtDate = createSelector(
      item => item['modified_at'],
      str => str ? new Date(str) : undefined
    )
    this.modifiedAtAgo = createSelector(
      this.modifiedAtDate,
      date => date ? ago(date) : undefined
    )
    this.imageSources = createSelector(
      [
        item => item['cover_image_urls'],
        item => item['cover_image_url']
      ],
      (coverImageUrls, coverImageUrl) => {
        if (coverImageUrls) {
          return [coverImageUrls.small, coverImageUrl]
        }
        return [coverImageUrl]
      }
    )

    // Event listeners

    this.onClick = this.onClick.bind(this)
  }

  // Event listeners

  onClick() {
    this.props.onClick(this.props.item)
  }

  // BEM helpers

  modifiers() {
    const { item } = this.props
    return {
      pending: item.isMixed === COLLECTION_UPDATE_PENDING,
      checked: item.isMixed === true,
      suggested: item.recommended && !item.id
    }
  }

  // Render functions

  renderAction() {
    return (
      tag('div', {
        className: bem.element('action')
      },
        tag('button', {
          className: bem.element('toggle')
        })
      )
    )
  }

  renderImage() {
    return (
      tag(LazyImage, {
        className: bem.element('image'),
        sources: this.imageSources(this.props.item)
      })
    )
  }

  renderName() {
    return (
      tag('div', {
        className: bem.element('name')
      },
        this.props.item.name
      )
    )
  }

  renderSubtitle() {
    const { item } = this.props
    const modifiedAtDate = this.modifiedAtDate(item)
    if (modifiedAtDate) {
      return (
        tag('time', {
          className: bem.element('subtitle'),
          dateTime: modifiedAtDate.toISOString()
        },
          'Last updated ' + this.modifiedAtAgo(item)
        )
      )
    }
    if (item.recommended && !item.id) {
      return (
        tag('div', {
          className: bem.element('subtitle')
        },
          'Suggested'
        )
      )
    }
    return null
  }

  renderPrivateIndicator(){
    if (this.props.item.visibility === VISIBILITY_PRIVATE) {
      return (
        tag('div', {
          className: bem.element('private')
        })
      )
    }
    return null
  }

  render() {
    return (
      tag('li', {
        className: classNames(
          this.props.className,
          bem.block(this.modifiers())
        ),
        onClick: this.onClick
      },
        this.renderImage(),
        tag('div', {
          className: bem.element('info')
        },
          this.renderName(),
          this.renderSubtitle()
        ),
        this.renderPrivateIndicator(),
        this.renderAction()
      )
    )
  }
}

CollectionSelectModalCollectionListItem.propTypes = {
  // Values
  className: PropTypes.string,
  item: PropTypes.shape(
    CollectionListItemRecord.propTypes
  ).isRequired,
  // Callbacks
  onClick: PropTypes.func
}

module.exports = CollectionSelectModalCollectionListItem
